import React, { useState } from 'react';
import { useAssessment } from '../../context/AssessmentContext';
import { LEVEL_A_QUESTIONS } from '../../config/assessmentConstants';
import styles from '../../styles/assessmentFlow.module.css';

const LevelAQuestions: React.FC = () => {
  const { dispatch } = useAssessment();
  const [answers, setAnswers] = useState<{ [key: string]: boolean }>({});
  const [currentQuestion, setCurrentQuestion] = useState(0);

  const handleAnswer = (questionId: string, answer: boolean) => {
    setAnswers(prev => ({ ...prev, [questionId]: answer }));
    
    // Auto-advance to next question after a short delay
    setTimeout(() => {
      if (currentQuestion < LEVEL_A_QUESTIONS.length - 1) {
        setCurrentQuestion(prev => prev + 1);
      } else {
        // If this is the last question (7th), automatically complete the assessment
        const allAnswers = { ...answers, [questionId]: answer };
        dispatch({ type: 'SET_LEVEL_A_ANSWERS', payload: allAnswers });
      }
    }, 300); // 300ms delay for smooth transition
  };

  const handleNext = () => {
    if (currentQuestion < LEVEL_A_QUESTIONS.length - 1) {
      setCurrentQuestion(prev => prev + 1);
    }
  };

  const handlePrevious = () => {
    if (currentQuestion > 0) {
      setCurrentQuestion(prev => prev - 1);
    }
  };

  const handleComplete = () => {
    // Ensure all questions are answered
    const allAnswered = LEVEL_A_QUESTIONS.every(q => answers[q.id] !== undefined);
    if (allAnswered) {
      dispatch({ type: 'SET_LEVEL_A_ANSWERS', payload: answers });
    }
  };

  const currentQ = LEVEL_A_QUESTIONS[currentQuestion];
  const isAnswered = answers[currentQ.id] !== undefined;
  const canComplete = LEVEL_A_QUESTIONS.every(q => answers[q.id] !== undefined);

  return (
    <div className={styles.levelAQuestions}>
      <div className={styles.questionContainer}>
        <div className={styles.questionHeader}>
          <div className={styles.questionNumber}>
            Question {currentQuestion + 1} of {LEVEL_A_QUESTIONS.length}
          </div>
          <div className={styles.runningTotal}>
            {Object.keys(answers).length}/{LEVEL_A_QUESTIONS.length}
          </div>
        </div>
        
        <div className={styles.questionText}>
          {currentQ.text}
        </div>

        <div className={styles.answerOptions}>
          <label className={styles.answerOption}>
            <input
              type="radio"
              name={currentQ.id}
              value="true"
              checked={answers[currentQ.id] === true}
              onChange={() => handleAnswer(currentQ.id, true)}
            />
            <span className={styles.answerText}>Yes</span>
          </label>
          
          <label className={styles.answerOption}>
            <input
              type="radio"
              name={currentQ.id}
              value="false"
              checked={answers[currentQ.id] === false}
              onChange={() => handleAnswer(currentQ.id, false)}
            />
            <span className={styles.answerText}>No</span>
          </label>
        </div>

        <div className={styles.questionNavigation}>
          <button
            onClick={handlePrevious}
            disabled={currentQuestion === 0}
            className={styles.navButton}
            type="button"
          >
            Previous
          </button>
          
          {currentQuestion < LEVEL_A_QUESTIONS.length - 1 && (
            <button
              onClick={handleNext}
              disabled={!isAnswered}
              className={styles.navButton}
              type="button"
            >
              Next
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default LevelAQuestions;
